<template>
    <div class="rsv_notice left_panel_item" @click="action_ClickBackground">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 100;">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                         xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="left_panel_title">
            <span class="title">{{ $t('reservationwindow.leftpannel.label_reservationdatenote') }}</span>
            <button class="btn_white btn_round mgl_auto" @click="action_ShowDateNotePopup">{{ $t('reservationwindow.leftpannel.button_seeall_title') }}</button>
        </div>
        <div class="notice_wrap">
            <textarea class="notice_textarea" :placeholder='$t("reservationwindow.leftpannel.textarea_placeholder")' maxlength="5000" :value="content" @input="updateContent" />
            <button class="btn_dgray btn_xs btn" @click="saveButtonClickAction" :disabled="!isDiff">{{ $t('reservationwindow.leftpannel.button_save_title') }}</button>
        </div>
    </div>
</template>

<script>
const moment = require('@/util/MPMoment')
import { showReservationDateNotePopup } from '../../../sheet-overlays'
import { exitTimeSelectMode } from '../../../reservation-selection'
import { sheetAxis } from '../../../sheet-axis'
import { sheetRefresh } from '../../../sheet-refresh'
import { useQueryClient } from '@tanstack/vue-query'
import { useV2ReservationDateNoteUpdateMutation } from '@/composables/queries/v2reservationdatenote/use-v2-reservation-datenote-update-mutation'
import { v2ReservationDateNoteFindQueryOptions } from '@/composables/queries/v2reservationdatenote/use-v2-reservation-datenote-find-query'

export default {
    setup() {
        // 워처 기반 명령형(await) 조회라 useQuery 대신 queryClient.fetchQuery 를 쓴다
        const queryClient = useQueryClient()
        const { mutateAsync: updateReservationDateNote } = useV2ReservationDateNoteUpdateMutation()
        return { queryClient, updateReservationDateNote }
    },
    props: {},
    data() {
        return {
            sheetAxis,
            sheetRefresh,
            isLoading: false,
            originalContent: '',
            content: ''
        }
    },
    watch: {
        'sheetRefresh.refreshFlagMoment': {
            handler: function (newValue) {
                if (!newValue) { return }
                if (this.isDiff == true) { return }
                this.requestFetchReservationDateNote()
            }
        },
        originalContent: {
            handler: function (newValue) {
                this.content = (newValue ?? '')
            }
        },
        'sheetRefresh.refreshDateNoteFlagMoment': {
            deep: true,
            handler: function () {
                if (this.isDiff == true) { return }
                this.requestFetchReservationDateNote()
            }
        },
        'sheetAxis.selectedDate': {
            immediate: true,
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.requestFetchReservationDateNote()
            }
        }
    },
    computed: {
        selectedDate: function () {
            return this.sheetAxis.selectedDate
        },
        isDiff: function () {
            return this.originalContent != this.content
        }
    },
    mounted() {
        this.requestFetchReservationDateNote()
    },
    methods: {
        // MARK: - Actions
        action_ClickBackground() {
            exitTimeSelectMode()
        },
        action_ShowDateNotePopup() {
            showReservationDateNotePopup()
        },
        saveButtonClickAction() {
            this.requestUpdateReservationDateNote()
        },
        // MARK: - Private
        updateContent(event) {
            this.content = event.target.value
        },

        // MARK: -Network
        async requestFetchReservationDateNote() {
            try {
                if (this.isLoading) { return }
                this.isLoading = true
                let param = {
                    hospitalID: this.hospital.selectedHospital._id,
                    date: moment(this.selectedDate).format('YYYY-MM-DD')
                }
                const data = await this.queryClient.fetchQuery(v2ReservationDateNoteFindQueryOptions(param))
                this.originalContent = new String(data?.[0]?.content ?? '')
            } catch (err) {
                console.log('reservation date note find error: ', err)
            } finally {
                this.isLoading = false
            }
        },

        async requestUpdateReservationDateNote() {
            try {
                this.isLoading = true
                let param = {
                    hospitalID: this.hospital.selectedHospital._id,
                    date: moment(this.selectedDate).format('YYYY-MM-DD'),
                    content: this.content
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                const updated = await this.updateReservationDateNote(param)
                this.originalContent = new String(updated.content)
            } catch (err) {
                console.log('reservation date note update error: ', err)
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>